import React, { useEffect, useState } from "react";
import AcademyHead from "./AcademyHead";
import Spinner from "../../components/spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";

interface IEvent {
  id?: string;
  title: string;
  firstText: string;
  secondText: string;
  images: string[];
  videoLink: string;
  companyName: string;
  companyPhone: string;
  companyEmail: string;
  companyAddress: string;
  companyLogo: string;
  companyAbout: string;
  endDate: string;
  status?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const AcademyEvents: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [events, setEvents] = useState<IEvent[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const getEvents = async () => {
      try {
        const response = await getFetcher(endpoints.eAcademy.getEvents);
        // console.log(response, 'responseresponse');
        if (response.result) {
          setEvents(response.events);
        } else {
          toast.error(
            "Error"
          );
        }
      } catch (error) {
        toast.error("Error");
        console.log(error);
      }
    };
    getEvents();
  }, []);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  // const events = [
  //   {
  //     logo: "https://media.istockphoto.com/id/1354776457/vector/default-image-icon-vector-missing-picture-page-for-website-design-or-mobile-app-no-photo.jpg?s=612x612&w=0&k=20&c=w3OW0wX3LyiFRuDHo9A32Q0IUMtD4yjXEvQlqyYk9O4=",
  //     companyName: "asd",
  //     email: "dsa@gmail.com",
  //     phone: "2243242342",
  //     address: "abcsadas qweqw",
  //   },
  //   {
  //     logo: "https://media.istockphoto.com/id/1354776457/vector/default-image-icon-vector-missing-picture-page-for-website-design-or-mobile-app-no-photo.jpg?s=612x612&w=0&k=20&c=w3OW0wX3LyiFRuDHo9A32Q0IUMtD4yjXEvQlqyYk9O4=",
  //     companyName: "asd",
  //     email: "dsa@gmail.com",
  //     phone: "2243242342",
  //     address: "abcsadas qweqw",
  //   },
  //   {
  //     logo: "https://media.istockphoto.com/id/1354776457/vector/default-image-icon-vector-missing-picture-page-for-website-design-or-mobile-app-no-photo.jpg?s=612x612&w=0&k=20&c=w3OW0wX3LyiFRuDHo9A32Q0IUMtD4yjXEvQlqyYk9O4=",
  //     companyName: "asd",
  //     email: "dsa@gmail.com",
  //     phone: "2243242342",
  //     address: "abcsadas qweqw",
  //   },
  //   {
  //     logo: "https://media.istockphoto.com/id/1354776457/vector/default-image-icon-vector-missing-picture-page-for-website-design-or-mobile-app-no-photo.jpg?s=612x612&w=0&k=20&c=w3OW0wX3LyiFRuDHo9A32Q0IUMtD4yjXEvQlqyYk9O4=",
  //     companyName: "asd",
  //     email: "dsa@gmail.com",
  //     phone: "2243242342",
  //     address: "abcsadas qweqw",
  //   },
  //   {
  //     logo: "https://media.istockphoto.com/id/1354776457/vector/default-image-icon-vector-missing-picture-page-for-website-design-or-mobile-app-no-photo.jpg?s=612x612&w=0&k=20&c=w3OW0wX3LyiFRuDHo9A32Q0IUMtD4yjXEvQlqyYk9O4=",
  //     companyName: "asd",
  //     email: "dsa@gmail.com",
  //     phone: "2243242342",
  //     address: "abcsadas qweqw",
  //   },
  // ];

  if (loading)
    return (
      <div>
        <Spinner />
      </div>
    );

  return (
    <div className=" flex flex-col gap-y-5 px-2 mb-20">
      {/* HEAD */}
      <div>
        <AcademyHead title={"ECZA AKADEMİ ETKİNLİKLER"} />
      </div>

      <div className="h-full p-2 grid grid-cols-1  2xl:grid-cols-2 gap-10">
        {events.map((event: any, i: number) => {
          return (
            <div
              onClick={() => navigate(`/academy/events-detail/${event?.id}`)}
              key={i}
              className="h-full rounded-xl shadow-lg hover:shadow-2xl cursor-pointer transition-all transform active:scale-95 w-full bg-white relative"
            >
              <div className="flex flex-col lg:flex-row h-full">
                <div className="w-full lg:w-1/3 flex justify-center items-center bg-gradient-to-b from-primary-color to-black rounded-t-xl lg:rounded-l-xl p-6 lg:rounded-r-none">
                  <img
                    className="w-[120px] lg:w-[180px] h-[120px] lg:h-[180px]  rounded-xl object-contain shadow-xl"
                    src={event.companyLogo}
                    alt={event.companyName}
                  />
                </div>

                <div className="flex flex-col lg:flex-row flex-[2] bg-gray-50 p-6 lg:p-10 rounded-b-xl lg:rounded-l-none gap-y-6 gap-x-6 ">
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">
                      Şirket Bilgileri
                    </h3>
                    <div className="space-y-4">
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Şirket Adı:</p>
                        <p className="text-gray-700">{event.companyName}</p>
                      </div>
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Şirket Maili:</p>
                        <p className="text-gray-700">{event.companyEmail}</p>
                      </div>
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Şirket Telefonu:</p>
                        <p className="text-gray-700">{event.companyPhone}</p>
                      </div>
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Şirket Adresi:</p>
                        <p className="text-gray-700">{event.companyAddress}</p>
                      </div>
                    </div>
                  </div>

                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">
                      Etkinlik Bilgileri
                    </h3>
                    <div className="space-y-4">
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Etkinlik Adı:</p>
                        <p className="text-gray-700">{event.title}</p>
                      </div>
                      <div className="flex flex-col gap-y-1 text-sm ">
                        <p className="font-medium">Etkinlik Tarihi:</p>
                        <p className="text-gray-700 font-semibold">
                          <span className=" text-green-700">
                            {new Date(event.createdAt).toLocaleDateString(
                              "tr-TR",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )}{" "}
                          </span>
                          -
                          <span className=" text-red-700">
                            {new Date(event.endDate).toLocaleDateString(
                              "tr-TR",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )}
                          </span>
                        </p>
                      </div>
                      {/* <div className="flex flex-col md:flex-row md:gap-4 text-sm">
                        <p className="font-medium">Etkinlik Yeri:</p>
                        <p className="text-gray-700">{event.eventLocation}</p>
                      </div> */}
                    </div>
                  </div>

                  <div className=" absolute bottom-0 md:bottom-5 right-0 md:right-5 mt-5  md:mt-0">
                    <button className=" text-primary-color hover:underline transition-all font-light">
                      Detaylar için tıklayınız
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AcademyEvents;
